import { render, staticRenderFns } from "./ReviewDrawer.vue?vue&type=template&id=f90a2174&scoped=true"
import script from "./ReviewDrawer.vue?vue&type=script&lang=js"
export * from "./ReviewDrawer.vue?vue&type=script&lang=js"
import style0 from "./ReviewDrawer.vue?vue&type=style&index=0&id=f90a2174&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90a2174",
  null
  
)

export default component.exports